import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "pt-5 grid grid-cols-4 gap-3" }
const _hoisted_4 = { class: "flex flex-col col-span-3" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "relative inline-block p-2 border border-next-neu hover:border-next-orange group mr-2 mb-2" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex flex-col mb-3" }
const _hoisted_10 = { class: "flex flex-col mb-3" }
const _hoisted_11 = { class: "flex flex-col mb-3" }
const _hoisted_12 = { class: "flex pt-3 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Dettaglio bilancio previsionale ", -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
      }, [
        _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
        _createElementVNode("i", {
          class: "icon-x cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
        })
      ], 2), [
        [_vShow, _ctx.response_message.length]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            field_name: "Cliente",
            errors: _ctx.getErrors('cliente_id'),
            placeholder: "Cliente"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.clienteAutocomplete.search,
                loading: _ctx.clienteAutocomplete.isLoading,
                options: _ctx.clienteAutocomplete.options,
                modelValue: _ctx.clienteAutocomplete.selection,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clienteAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "denominazione",
                class: "next-vue-multiselect-single",
                placeholder: "Cliente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                option: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            field_name: "Business Unit",
            placeholder: "Business Unit",
            errors: _ctx.getErrors('business_unit_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                "internal-search": false,
                loading: _ctx.buAutocomplete.isLoading,
                trackBy: "id",
                label: "label",
                modelValue: _ctx.buAutocomplete.selection,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                options: _ctx.buAutocomplete.options,
                onSearchChange: _ctx.buAutocomplete.search,
                multiple: false,
                class: "next-vue-multiselect-single",
                "close-on-select": true,
                "clear-on-select": true,
                placeholder: "Business Unit",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(option.label), 1),
                    _createElementVNode("i", {
                      tabindex: "1",
                      onClick: _withModifiers(($event: any) => (remove(option)), ["stop","prevent"]),
                      class: "cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            field_name: "Anno",
            modelValue: _ctx.model.anno,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.anno) = $event)),
            type: "number",
            inputAttrs: {step:'1'},
            errors: _ctx.getErrors('anno')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            field_name: "Previsionale",
            modelValue: _ctx.model.previsto,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.previsto) = $event)),
            type: "number",
            inputAttrs: {step:'0.01'},
            errors: _ctx.getErrors('previsto')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            field_name: "Progressivo",
            modelValue: _ctx.model.progresso,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.progresso) = $event)),
            type: "number",
            inputAttrs: {step:'0.01'},
            errors: _ctx.getErrors('progresso')
          }, null, 8, ["modelValue", "errors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_NextButton, {
          class: "px-3 py-2",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("Salva")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}